function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg236Tajikistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.007,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.336,
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "213.259,320.926 298.741,320.926 298.741,284.596 281.645,293.144 256,267.5    230.355,293.144 213.259,284.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "164.351,278.185 168.33,290.43 181.203,290.43 170.789,297.997 174.767,310.241    164.351,302.673 153.936,310.241 157.914,297.997 147.499,290.43 160.373,290.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "176.687,235.445 180.665,247.689 193.539,247.689 183.123,255.256 187.101,267.5    176.687,259.934 166.271,267.5 170.249,255.256 159.834,247.689 172.708,247.689  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "211.949,203.39 215.927,215.633 228.802,215.633 218.386,223.201 222.364,235.445    211.949,227.878 201.533,235.445 205.511,223.201 195.096,215.633 207.97,215.633  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "347.648,278.185 343.67,290.43 330.795,290.43 341.211,297.997 337.233,310.241    347.648,302.673 358.064,310.241 354.086,297.997 364.501,290.43 351.627,290.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "335.313,235.445 331.335,247.689 318.461,247.689 328.877,255.256 324.898,267.5    335.313,259.934 345.729,267.5 341.751,255.256 352.166,247.689 339.292,247.689  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "300.051,203.39 296.072,215.633 283.198,215.633 293.614,223.201 289.636,235.445    300.051,227.878 310.467,235.445 306.489,223.201 316.903,215.633 304.03,215.633  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,187.361 259.979,199.605 272.853,199.605 262.437,207.172 266.416,219.416 256,211.849    245.584,219.416 249.563,207.172 239.147,199.605 252.021,199.605  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg236Tajikistan);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };